(function (Drupal) {
  'use strict';

  Drupal.behaviors.inlineVideo = {
    attach: function (context) {
      // Handles autoplay for inline video

      let videos = context.querySelectorAll('.js-paragraph-video:not(.video--view-mode-gallery-main) video:not(.hero video)');

      videos.forEach(function (video) {
        let toggle = video.parentElement.querySelector('.js-video-toggle');
        const mq = window.matchMedia("(min-width: 768px)");

        if (mq.matches) {
          video.play();
          toggle.classList.remove('paused');
          video.style.display = 'flex';
        }

        mq.addEventListener('change', (e) => {
          if (e.matches) {
            video.play();
            toggle.classList.remove('paused');
            video.style.display = 'flex';
          }
          else {
            video.pause();
            toggle.classList.add('paused');
            video.style.display = 'none';
          }
        });

        toggle.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            toggle.classList.remove('paused');
          }
          else {
            video.pause();
            toggle.classList.add('paused');
          }
        });
      });
    }
  };

  Drupal.behaviors.heroVideo = {
    attach: function (context) {
      let mobileHeroVideo = context.querySelector('.hero .mobile-image-wrapper video');
      let mobilePlayBtn;
      if(mobileHeroVideo) {
        mobilePlayBtn = mobileHeroVideo.parentElement.querySelector('.js-video-toggle');
        mobilePlayBtn.classList.remove('paused');
        mobilePlayBtn.addEventListener('click', () => {
          if(mobileHeroVideo.paused) {
            mobileHeroVideo.play();
            mobilePlayBtn.classList.remove('paused');
          } else {
            mobileHeroVideo.pause();
            mobilePlayBtn.classList.add('paused');
          }
        });
      }

      let desktopHeroVideo = context.querySelector('.hero .desktop-media-wrapper video');
      let desktopPlayBtn;
      if(desktopHeroVideo) {
        desktopPlayBtn = desktopHeroVideo.parentElement.querySelector('.js-video-toggle');
        desktopPlayBtn.classList.remove('paused');
        desktopPlayBtn.addEventListener('click', () => {
          if(desktopHeroVideo.paused) {
            desktopHeroVideo.play();
            desktopPlayBtn.classList.remove('paused');
          } else {
            desktopHeroVideo.pause();
            desktopPlayBtn.classList.add('paused');
          }
        });
      }

      const mq = window.matchMedia("(min-width: 768px)");

      if( mq.matches ) {
        desktopHeroVideo && desktopHeroVideo.play();
        mobileHeroVideo && mobileHeroVideo.pause();
      } 

      if( !mq.matches ) {
        mobileHeroVideo && mobileHeroVideo.play();
        desktopHeroVideo && desktopHeroVideo.pause();
      }

      // listening for viewport change
      mq.addEventListener('change', e => {
        if (e.matches) { // if over 768px viewport width, check for desk and mobile hero and if they exist, play/pause them
          desktopHeroVideo && desktopHeroVideo.play();
          mobileHeroVideo && mobileHeroVideo.pause();
          desktopPlayBtn && desktopPlayBtn.classList.remove('paused');
        } else {
          mobileHeroVideo && mobileHeroVideo.play();
          desktopHeroVideo && desktopHeroVideo.pause();
          mobilePlayBtn && mobilePlayBtn.classList.remove('paused');
        }
      });
    }
  };
}(Drupal));